import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import AnimatedIcon from './AnimatedIcon';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { to: '/', label: 'Задачи', icon: 'books', match: (p) => p === '/' || p.startsWith('/topic') || p.startsWith('/workspace') },
  { to: '/course', label: 'Курс', icon: 'diploma', match: (p) => p.startsWith('/course') },
  { to: '/homework', label: 'ДЗ', icon: 'pencil', match: (p) => p.startsWith('/homework') },
  { to: '/errors', label: 'Поиск ошибок', icon: 'nuke_error', match: (p) => p.startsWith('/errors') },
  { to: '/lab', label: 'Лаборатория', icon: 'science', match: (p) => p.startsWith('/lab') },
  { to: '/explorer', label: 'MathLib', icon: 'catalogue', match: (p) => p.startsWith('/explorer') },
  { to: '/standup', label: 'Стендап', icon: 'clown', match: (p) => p.startsWith('/standup') },
  { to: '/archive', label: 'Архив', icon: 'lib_laoder', match: (p) => p.startsWith('/archive') },
];

function Header() {
  const path = useLocation().pathname;
  const { user, signOut } = useAuth();

  return (
    <header className="header">
      <Link to="/" className="header-logo">
        <img src="/mfti-logo.svg" alt="МФТИ" style={{ filter: 'brightness(0) invert(1)' }} />
        <div>
          <div className="header-title">COMB-AI<sup style={{ fontSize: '0.6em' }}>n</sup></div>
          <div className="header-subtitle">AI4Math · ОКТЧ МФТИ</div>
        </div>
      </Link>

      <nav className="header-nav">
        {NAV.map((item) => {
          const active = item.match(path);
          return (
            <Link key={item.to} to={item.to} className={`nav-item${active ? ' active' : ''}`}>
              {/* На активном пункте фон белый — иконку красим в бренд, иначе она исчезает */}
              <AnimatedIcon name={item.icon} size={22} playOnHover tone={active ? 'brand' : 'onDark'}
                            style={{ marginRight: 6 }} title={item.label} />
              <span className="nav-label">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {user && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 'auto', paddingLeft: 12 }}>
          <Link to="/me" className={`nav-item${path.startsWith('/me') ? ' active' : ''}`}
                style={{ display: 'flex', alignItems: 'center', gap: 8 }} title="Моё пространство">
            <AnimatedIcon name="planet" size={22} playOnHover tone={path.startsWith('/me') ? 'brand' : 'onDark'} />
            <span style={{ lineHeight: 1.1 }}>
              <span style={{ display: 'block' }}>{user.full_name}</span>
              <span style={{ display: 'block', fontSize: 11, opacity: 0.8 }}>
                {user.points} очк.{user.rank ? ` · ${user.rank} место` : ''} · неделя {user.week}
              </span>
            </span>
          </Link>
          {user.is_staff && (
            <a href="/admin/" className="nav-item" title="Административное пространство">Админка</a>
          )}
          <button onClick={signOut} className="nav-item"
                  style={{ background: 'none', border: 'none', cursor: 'pointer', font: 'inherit' }}
                  title="Выйти">Выйти</button>
        </div>
      )}
    </header>
  );
}

export default Header;
